import React from 'react';
import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';

const AlbumLink = ({ albumTitle, albumId, albumSourceId, albumSource, albumSlug, sx, onClick }) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();
  const displayTitle = albumTitle || 'Unknown Album';
  const canClick = !!(albumSlug || albumSourceId || albumId);
  const albumUrl = canClick
    ? albumSlug
      ? `/reviews/${albumSlug}`
      : albumSourceId
        ? `/reviews/${albumSource?.toLowerCase()}/${albumSourceId}`
        : `/reviews/local/${albumId}`
    : '#';

  const handleClick = (e) => {
    if (canClick) {
      e.stopPropagation();
      onClick?.();
      if (!e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        navigateWithScrollMemory(albumUrl);
      }
    } else {
      e.preventDefault();
    }
  };

  return (
    <RouterLink
      to={albumUrl}
      onClick={handleClick}
      style={{
        textDecoration: 'none',
        color: 'inherit',
        pointerEvents: canClick ? 'auto' : 'none',
      }}
    >
      <Typography
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          cursor: canClick ? 'pointer' : 'default',
          lineHeight: 'normal',
          ...sx,
        }}
        title={displayTitle}
      >
        {displayTitle}
      </Typography>
    </RouterLink>
  );
};

export default AlbumLink;
